import * as React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";

export default function AlertLoading({ text = "Veriler Yükleniyor..." }) {
    return (
        <MDBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            mt={6}
            p={4}
            sx={{
                backgroundColor: "#EEF6FF",
                border: "1px dashed #66B2FF",
                borderRadius: "12px",
                width: "90%",
                mx: "auto"
            }}
        >
            {/* <CircularProgress sx={{ color: "#1976d2", mb: 2 }} /> */}

            <MDTypography variant="h6" fontWeight="medium" color="info">
                {text}
            </MDTypography>
        </MDBox>
    );
}